<div [formGroup]="pisForm">

    <app-ativacao-section-card
        [control]="isAtivoControl"
        titulo="PIS"
        descricaoAtivo="PIS ativo. A regra padrão e as exceções abaixo serão aplicadas no cálculo desta natureza de operação."
        descricaoInativo="PIS inativo. Nenhum valor de PIS será calculado nesta natureza de operação."
        emptyStateDescricao="Ative o PIS acima para configurar a regra padrão, as observações e as exceções deste tributo.">
    </app-ativacao-section-card>

    @if (isAtivoControl.value) {

    <!-- ── Regra Padrão ──────────────────────────────────────────────── -->
    <app-pis-tributo-regra-section
        [form]="pisForm"
        [codigoTributos]="codigoTributos"
        [modalidadesBcSt]="modalidadesBcSt"
        [personalizadasCount]="personalizadasCount"
        [personalizarDisabled]="formulasParaCodigoTributo.length === 0"
        [tipoOperacao]="tipoOperacaoValue"
        (personalizar)="abrirEditorFormulas()">
    </app-pis-tributo-regra-section>

    <!-- ── Observações ────────────────────────────────────────────────── -->
    <app-pis-tributo-observacoes-section
        [control]="$any(pisForm.get('observacao'))"
        [variaveis]="pisForm.get('cstPis')?.value ? variaveisUnicas : []"
        titulo="Informações complementares"
        icone="notes"
        placeholder="Texto da observação que será impresso no documento fiscal..."
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-pis-tributo-observacoes-section>

    <!-- ── Informações adicionais ao fisco ───────────────────────────────────────── -->
    <app-pis-tributo-observacoes-fisco-section
        [control]="$any(pisForm.get('observacaoFisco'))"
        [variaveis]="pisForm.get('cstPis')?.value ? variaveisUnicas : []"
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-pis-tributo-observacoes-fisco-section>

    <!-- ── Exceções ───────────────────────────────────────────────────── -->
    <app-pis-tributo-excecoes-section
        [idNaturezaOperacao]="idNaturezaOperacao"
        [codigoTributos]="codigoTributos"
        [modalidadesBcSt]="modalidadesBcSt"
        [variaveis]="variaveisUnicas"
        [formulasPis]="formulasPis"
        [tipoOperacao]="tipoOperacaoValue"
        [excecoesPendentes]="excecoesPendentes"
        (excecoesChange)="excecoesChange.emit($event)">
    </app-pis-tributo-excecoes-section>

    }

</div>
